import { useEffect } from 'react';
import { useSiteTheme } from '../hooks/useSiteTheme';

const TYPO_KEY = 'tasking-user-typography';

/** Invisible component that loads and applies the user's saved site theme on app start */
export const SiteThemeLoader = () => {
  useSiteTheme(); // This hook handles localStorage cache + DB fetch + applying CSS vars

  // Apply standalone typography overrides from localStorage
  useEffect(() => {
    try {
      const raw = localStorage.getItem(TYPO_KEY);
      if (!raw) return;
      const { fontFamily, fontSize, fontStyle } = JSON.parse(raw);
      const set = (v: string, val: string) => {
        document.documentElement.style.setProperty(v, val);
        document.body.style.setProperty(v, val);
      };
      if (fontFamily) {
        set('--font-family-base', fontFamily);
        set('--font-family-heading', fontFamily);
        // Dynamically load Google Font
        const match = fontFamily.match(/"([^"]+)"/);
        const name = match?.[1];
        if (name) {
          const SYSTEM = ['Arial','Helvetica Neue','Verdana','Tahoma','Times New Roman','Georgia','Consolas','Menlo','Courier New'];
          if (!SYSTEM.includes(name)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${name.replace(/ /g, '+')}:ital,wght@0,200..900;1,200..900&display=swap`;
            document.head.appendChild(link);
          }
        }
      }
      if (fontSize) { set('--theme-base-font-size', fontSize); document.documentElement.style.fontSize = fontSize; }
      if (fontStyle) { set('--font-style-base', fontStyle); }
    } catch {}
  }, []);

  return null;
};
